import { Link } from 'react-router-dom'
import { ChevronRight, type LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

interface StaticPageProps {
  title: string
  subtitle?: string
  icon?: LucideIcon
  children: ReactNode
}

export function StaticPage({ title, subtitle, icon: Icon, children }: StaticPageProps) {
  return (
    <div className="max-w-[1000px] mx-auto px-6 py-6">
      <nav className="flex items-center gap-1.5 text-sm text-muted mb-4">
        <Link to="/" className="hover:text-brand-600">Trang chủ</Link>
        <ChevronRight className="w-3.5 h-3.5" />
        <span className="text-text font-medium">{title}</span>
      </nav>

      <div className="rounded-xl overflow-hidden bg-gradient-to-br from-brand-600 to-brand-700 text-white p-8 mb-6 relative">
        <div className="relative flex items-center gap-4">
          {Icon && (
            <div className="w-16 h-16 rounded-2xl bg-white/15 backdrop-blur-sm flex items-center justify-center">
              <Icon className="w-8 h-8" />
            </div>
          )}
          <div>
            <h1 className="text-2xl md:text-3xl font-bold">{title}</h1>
            {subtitle && <p className="text-sm text-white/80 mt-1.5 max-w-2xl">{subtitle}</p>}
          </div>
        </div>
      </div>

      <article className="bg-surface border border-border rounded-xl shadow-card p-8 prose prose-slate max-w-none">
        {children}
      </article>
    </div>
  )
}
